/*
  recently-viewed.js — Recently Viewed Products (Recién vistos) v3

  Flow:
  1. En cada PDP, snippet liquid setea window.__rvCurrent = { id, handle }.
     Si está presente, este script lo agrega al localStorage (FIFO, max N).
  2. En cualquier página con <recently-viewed-products> renderizado:
     - Lee handles del localStorage, filtra el current product
     - Por cada handle, fetcha /products/{handle}?section_id=rv-card via Section Rendering API
     - Extrae el card HTML del response y lo inyecta en el grid container
     - Si no hay productos para mostrar, oculta la section
*/
(function() {
  'use strict';

  if (window.__RV_LOADED__) return;
  window.__RV_LOADED__ = true;

  var STORAGE_KEY = 'rv_products_v3';
  var MAX_ITEMS = 4;
  var SECTION_ID = 'rv-card';

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) {}
  }

  // 1) Track current PDP — guardar { id, handle }
  function trackCurrent() {
    var current = window.__rvCurrent;
    if (!current || !current.id || !current.handle) return;
    var list = readList();
    list = list.filter(function(p) { return p.id !== current.id; });
    list.push({ id: current.id, handle: current.handle });
    while (list.length > MAX_ITEMS) list.shift();
    writeList(list);
  }

  // 2) Fetch single card HTML via Section Rendering API
  function fetchCard(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;
    return fetch(url, { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(html) {
        // El section response es el HTML de la section completa. Extraemos solo
        // el wrapper interno (que tiene la card del producto).
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-rv-card-wrapper]');
        // Sin wrapper = el producto ya no existe: se marca para sacarlo de la lista
        return card ? card.innerHTML : null;
      })
      .catch(function() { return ''; });
  }

  // 3) Render: para cada producto en localStorage (menos el current), fetchar
  // el card y armarlos en el container. Si vacío, ocultar section.
  function render() {
    var wrappers = document.querySelectorAll('recently-viewed-products');
    if (!wrappers.length) return;

    var list = readList();
    var currentId = (window.__rvCurrent && window.__rvCurrent.id) || null;
    var filtered = list.filter(function(p) { return p.id !== currentId; }).reverse();

    for (var w = 0; w < wrappers.length; w++) {
      var wrapper = wrappers[w];
      var container = wrapper.querySelector('[data-rv-container]');
      var section = wrapper.closest('.mount-recently-viewed-products') || wrapper;

      if (!filtered.length) {
        section.style.display = 'none';
        continue;
      }

      if (!container) continue;

      // Fetch cards en paralelo, preservando orden
      var fetches = filtered.map(function(p) { return fetchCard(p.handle); });
      Promise.all(fetches).then(function(htmls) {
        var combined = '';
        var gone = [];
        for (var i = 0; i < htmls.length; i++) {
          if (htmls[i]) combined += htmls[i];
          else if (htmls[i] === null) gone.push(filtered[i].handle);
        }
        if (gone.length) writeList(readList().filter(function(p) { return gone.indexOf(p.handle) === -1; }));
        if (combined) {
          container.innerHTML = combined;
          section.style.display = '';
        } else {
          section.style.display = 'none';
        }
      });
    }
  }

  function init() {
    trackCurrent();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
